<div class="main-element">
    <app-complete-registration *ngIf="completeRegistrationRequired$ | async"></app-complete-registration>
    <app-registration-pending *ngIf="registrationPendingApproval$ | async"></app-registration-pending>
</div>